var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleModalBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2317_174350",
    style: {
      masktype: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -120,
    y: -120,
    width: 336,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    transform: "translate(-120 -120)",
    fill: "url(#paint0_radial_2317_174350)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2317_174350)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.5,
    stroke: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 71.5,
    stroke: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 95.5,
    stroke: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 119.5,
    stroke: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 143.5,
    stroke: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 167.5,
    stroke: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2317_174350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168 168) rotate(90) scale(168 168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleModalBackground);
export default __webpack_public_path__ + "static/media/circle-modal-background.23f2d6a340c7e871c35cfbc78171f480.svg";
export { ForwardRef as ReactComponent };